<template lang='pug'>
	.modal(:class='state' @click.self='close')
		.modal-content
			slot(name='content')
</template>

<script>
export default {
	name : 'modal',

	props : {
		state : {
			type : String, // should either be 'opened' or 'closed'
		},
	},

	methods : {
		close() {
			this.$emit( 'close' );
		}
	}
};
</script>

<style lang="scss">
	.modal {
		position: fixed;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		z-index: 10;
		opacity: 0;
		pointer-events: none;

		&.opened, &.failed {
			opacity: 1;
			pointer-events: all;
		}
	}
</style>
